module.exports = __webpack_public_path__ + "static/img/img21.82db03a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img21.png
// module id = 6TBf
// module chunks = 1